
import { Image } from "element-ui"
import { getPandoraCoupon } from "@/api/dshop"
import { formatImgUrl } from "@/utils/utils"

export default {
  name: "ImageArea",
  components: {
    [Image.name]: Image
  },
  props: {
    module: Object
  },
  data() {
    return {
      isLoadErr: false
    }
  },
  computed: {
    imgBgColor() {
      return this.module?.data?.imgBgColor
    },
    areas() {
      return this.module?.data?.areas || []
    }
  },
  methods: {
    onClickMap(record) {
      // redirectType 1: 跳转链接， 2: 商品详情, 11: 领券, 9: 跳转楼层
      if (record.redirectType === "1") {
        this.$navigation.push(record.link.app)
      } else if (record.redirectType === "2") {
        this.$navigation.push(`${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${record.link}`)
      } else if (record.redirectType === "11") {
        this.getCoupon(record)
      } else if (record.redirectType === "9") {
        this.scrollToFloor(record)
      }
    },
    /**
     * 获取优惠券
     */
    async getCoupon(param) {
      const { data } = await getPandoraCoupon({
        param: JSON.stringify({
          taskId: param.link,
          rewardItemId: param.rewardItemId
        })
      })
      const { code, customMessage } = data || {}
      if (code === "0000") {
        this.$message.success(customMessage)
      } else if (code === "1004") {
        // 已经领取过
        this.$message.error(customMessage)
      } else {
        this.$message.error(customMessage + "(" + code + ")")
      }
    },
    /**
     * 跳转指定楼层
     */
    scrollToFloor(record) {
      const anchorId = `anchor-${record.link}`
      const anchorElement = document.getElementById(anchorId)
      if (anchorElement) {
        const headerHeight = document.getElementById("top-box").clientHeight
        const offsetTop = anchorElement.getBoundingClientRect().top + window.scrollY
        window.scrollTo({
          top: offsetTop - headerHeight,
          behavior: "smooth"
        })
      } else {
        console.warn(`未找到楼层: ${anchorId}`)
      }
    },
    onLoadImageError() {
      this.isLoadErr = true
    },
    formatImgUrl
  }
}
